/* 템플릿 분류 탭 — 동그란 아이콘 + 이름. 표준 Tabs 는 글자만 있어서 이 화면 전용으로 만든다(시공사례 홈에서만 씀).
   눌리는 부분은 ui-core temp_TileButton, 모양은 토큰 유틸만. 키보드: ←/→ 로 옆 분류 */
import type { KeyboardEvent, ReactNode } from 'react';
import { Temp_TileButton } from '@indipia/ui-core';
import { cx } from './ui';

export interface CategoryTab { value: string; label: string; icon: ReactNode }

export function CategoryTabs({ tabs, value, onChange, label }: { tabs: CategoryTab[]; value: string; onChange: (v: string) => void; label: string }) {
  const move = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    const i = tabs.findIndex((t) => t.value === value);
    const next = tabs[(Math.max(0, i) + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
    onChange(next.value);
    e.currentTarget.querySelector<HTMLElement>(`[data-tab="${next.value}"]`)?.focus();
  };
  return (
    <div role="tablist" aria-label={label} className="flex flex-wrap justify-center gap-lg" onKeyDown={move}>
      {tabs.map((t) => {
        const on = t.value === value;
        return (
          <Temp_TileButton key={t.value} plain role="tab" aria-selected={on} tabIndex={on || (!tabs.some((x) => x.value === value) && t === tabs[0]) ? 0 : -1} data-tab={t.value}
            className="flex flex-col items-center gap-sm rounded-md p-02" onClick={() => onChange(t.value)}>
            <span className={cx('flex size-[var(--num-56)] items-center justify-center rounded-full border border-solid',
              on ? 'border-group bg-group text-group-onPrimary' : 'border-[var(--neutral-200)] bg-group-subtle text-group group-hover:bg-[var(--neutral-100)]')}>
              {t.icon}
            </span>
            <span className={cx('text-caption', on ? 'font-semibold text-group' : 'font-medium text-text-secondary')}>{t.label}</span>
          </Temp_TileButton>
        );
      })}
    </div>
  );
}
